import { RiProfileLine, RiProfileFill } from '@remixicon/react'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'
import {
  Perm_Order_Menu_View,
  Perm_Order_Menu_View_Kt,
  Perm_Order_TransportCoordination_View,
  Perm_Order_View,
  Perm_Shipment_View,
  Perm_Shipment_View_Kt
} from '../../app/hooks/premissionScreen'

const icons = {
  RiProfileLine,
  RiProfileFill
}

export const orderMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'order',
    title: 'Quản lý đơn hàng',
    icon: icons.RiProfileLine,
    iconActive: icons.RiProfileFill,
    premissions: Perm_Order_View,
    children: [
      createItem({
        id: 'order-list',
        title: 'Đơn hàng',
        url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
        premissions: Perm_Order_Menu_View
      }),
      createItem({
        id: 'order-shipment',
        title: 'Lô hàng',
        url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_SHIPMENT}`,
        premissions: Perm_Shipment_View
      }),
      createItem({
        id: 'order-list-kt',
        title: 'Đơn hàng KT',
        url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST_KT}`,
        premissions: Perm_Order_Menu_View_Kt
      }),
      createItem({
        id: 'order-shipment-kt',
        title: 'Lô hàng KT',
        url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_SHIPMENT_KT}`,
        premissions: Perm_Shipment_View_Kt
      }),
      createCollapseGroup({
        id: 'order-transportCoordination',
        title: 'Điều phối',
        // url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_TRANSPORTCOORDINATION}`,
        premissions: Perm_Order_TransportCoordination_View,
        children: [
          createItem({
            id: 'order-transportCoordination-car',
            title: 'Điều phối xe',
            url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_TRANSPORTCOORDINATION}`,
            premissions: Perm_Order_TransportCoordination_View
          }),
          createItem({
            id: 'order-maintenance-schedule',
            title: 'Lịch bảo dưỡng',
            url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_MAINTENANCE_SCHEDULE}`,
            premissions: Perm_Order_TransportCoordination_View
          }),
          createItem({
            id: 'order-vacation-schedule',
            title: 'Lịch nghỉ',
            url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_VACATION_SCHEDULE}`,
            premissions: Perm_Order_TransportCoordination_View
          }),
          createItem({
            id: 'order-registration-inspection-schedule',
            title: 'Lịch đăng ký đăng kiểm',
            url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_REGISTRATIONINSPECTION_SCHEDULE}`,
            premissions: Perm_Order_TransportCoordination_View
          })
        ]
      })
      //   createCollapseGroup({
      //     id: 'order-genus-history',
      //     title: 'Lịch sử chi',
      //     premissions: [PERMISSION.ADMIN],
      //     children: [
      //       createItem({
      //         id: 'order-genus-history-oli',
      //         title: 'Dầu không khoán',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-edit-repair',
      //         title: 'Sửa chữa',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-cost-general',
      //         title: 'Quản lý chung',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-cost-road',
      //         title: 'Tiền đường',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-cost-bonus',
      //         title: 'Thưởng',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       })
      //     ]
      //   }),
      //   createCollapseGroup({
      //     id: 'order-norms',
      //     title: 'Định mức thanh toán',
      //     premissions: [PERMISSION.ADMIN],
      //     children: [
      //       createItem({
      //         id: 'order-norms-salary-month',
      //         title: 'Lương tháng',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-norms-salary-order',
      //         title: 'Lương chuyến',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       }),
      //       createItem({
      //         id: 'order-norms-degradation',
      //         title: 'Định mức tiêu hao xe',
      //         url: `/${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`,
      //         premissions: [PERMISSION.ADMIN]
      //       })
      //     ]
      //   })
    ]
  })
]
